<template>
  <div class="search-quote-card card mx-0 p-0">
    <div class="fixed-grid has-12-cols p-1">
      <div class="grid">

        <div class="cell is-col-span-4">
          <figure class="image is-128x128 p-3">
            <div class="skeleton-image" />
          </figure>
        </div>

        <div class="cell is-col-span-8">
          <div class="is-flex is-flex-direction-column is-size-7"
            style="width: 100%;">
            <div class="is-flex is-align-items-center is-justify-content-space-between has-background-grey-lighter p-1">
              <div class="skeleton-text skeleton-text-medium" />
              <div class="skeleton-text skeleton-text-small" />
            </div>

            <div class="is-flex is-align-items-center is-justify-content-space-between my-2">
              <div class="skeleton-text skeleton-text-large" />
              <div class="skeleton-text skeleton-text-small" />
            </div>

            <div class="is-flex is-align-items-center is-justify-content-space-between mb-2">
              <div class="skeleton-text skeleton-text-medium" />
              <div class="skeleton-text skeleton-text-small" />
            </div>

            <div class="is-flex is-align-items-center is-justify-content-space-between">
              <div class="skeleton-text skeleton-text-medium" />
              <div class="skeleton-text skeleton-text-large" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalSearchSkeletonCard'
}
</script>

<style lang="scss" scoped>
.search-quote-card {
  height: 128px;
  border: 1px solid transparent;
}

/* Skeleton animation */
@keyframes skeleton-loading {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
}

.skeleton-image,
.skeleton-text {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200px 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-image {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.skeleton-text {
  height: 14px;
  margin: 2px 0;
}

.skeleton-text-small {
  width: 60px;
}

.skeleton-text-medium {
  width: 100px;
}

.skeleton-text-large {
  width: 80px;
}

/* Override text sizes for different skeleton elements */
.skeleton-text:nth-child(1) {
  height: 12px; /* Smaller for date text */
}

.skeleton-text:nth-child(2) {
  height: 16px; /* Larger for quote number */
}
</style>
